import { IntegrationType } from '../integrations-client/integrations-client.type';
import type { Sprint, SprintSummary } from '../sprints-client/sprints-client.type';

enum SubprojectMethodology {
  Scrum = 'scrum',
  Kanban = 'kanban',
}

type ProjectsResponse = {
  id: string;
  name: string;
  pm?: string;
  pm_tool?: string;
  task_count?: number;
  contributor_count?: number;
  subprojects: Subproject[];
};

type Team = {
  id: string;
  name: string;
  subprojects: Board[];
};

type Board = {
  id: string;
  name: string;
};

type SubProjectSprint = [string, string];

type SubProjectSprints = {
  [key: string]: SubProjectSprint[];
};

type ProjectBoardSprints = {
  subproject_sprints: SubProjectSprints;
};

type SubprojectViewData = {
  name: string;
  subproject_view_data: Project | Sprint;
};

type SubprojectResponse = {
  subproject_data?: SubprojectViewData[];
};

enum ConfigurationState {
  NotConfigured = 'not_configured',
  InitiallyConfigured = 'initially_configured',
}

type Subproject = {
  id: string;
  name: string;
  configuration_state: ConfigurationState | null;
  sprint_count: number;
};

type Project = {
  id: string;
  name: string;
  integration_type: IntegrationType;
  current_sprint: Sprint;
  current_sprints: Sprint[];
  sprints: SprintSummary[];
  subprojects: Subproject[];
  pm?: string;
  pm_tool?: string;
  sprint_length_in_days: number;
  backlog_sections: string[];
  in_progress_sprint_sections: string[];
  in_blocked_sprint_sections: string[];
  in_review_sprint_sections: string[];
  in_test_sprint_sections: string[];
  ready_for_deployment_sprint_sections: string[];
  active_sprint_sections: string[];
  sections_done: string[];
};

type CreateProjectPayload = {
  name: string;
  portfolioId: string;
  subprojectIds: string[];
};

type UpdateProjectPayload = {
  id: string;
  name: string;
  subproject_ids: string[];
};

type ExternalProject = {
  expand: string;
  self: string;
  id: string;
  key: string;
  name: string;
  projectTypeKey: string;
  simplified: boolean;
  style: string;
  isPrivate: boolean;
  entityId?: string;
  uuid?: string;
};

type ExternalProjectLocation = {
  projectId: string;
  displayName: string;
  projectName: string;
  projectKey: string;
  projectTypeKey: string;
  avatarURI: string;
  name: string;
};

type ExternalBoard = {
  self: string;
  id: string;
  type: string;
  name: string;
  location: ExternalProjectLocation;
};

export { ConfigurationState, SubprojectMethodology };
export type {
  Board,
  CreateProjectPayload,
  ExternalBoard,
  ExternalProject,
  Project,
  ProjectBoardSprints,
  ProjectsResponse,
  Subproject,
  SubprojectResponse,
  Team,
  UpdateProjectPayload,
};
